<template>
  <div class="container tooltip-content" v-if="!dataConfirmContractStatus">
    <div class="row">
      <!-- Левая колонка -->

      <div class="col-lg-6 col-sm-12 d-flex flex-column justify-content-center">
        <div class="discount-info-block">
          <p class="mb-1">Будь ласка, вкажіть <span class="red">ціну</span> за якою було <span class="red">продано поліс</span>, клієнту</p>
          <p class="mb-1"> Це необхідно для:</p>
          <ul class="mb-1">
            <li>Коректного розрахунку виплат КВ з урахуванням знижки.</li>
            <li>Відображення реальної ціни поліса в аналітиці.</li>
            <li>Формування звітів та документів з актуальними фінансовими даними.</li>
          </ul>
        </div>
      </div>

      <div  v-loading="dataLoading" class="col-lg-6 col-sm-12 flex-column align-items-center">
        <div class="form-group flex-column w-100 discount-slider-wrap">
          <input :disabled="dataOtpFlags.confirmOtpStatus || isDiscountDisabled" v-model.number="paySum" type="text" placeholder="сумма" :class="['form-control', {invalid: ($v.paySum.$error  && submited)}]">
          <vue-slider v-model.lazy="paySum"
                      class="discount-slider"
                      tooltip="always"
                      :disabled="dataOtpFlags.confirmOtpStatus || isDiscountDisabled"
                      :min="Math.floor(nettoPrice)"
                      :max="Math.floor(maxValueForPaySum)"
                      :interval="1"
                      :process="sliderProcess"
                      :dot-options="sliderDotOptions"
                      :marks="sliderMarks">
          </vue-slider>
          <small v-if="isDiscountDisabled" class="red">Знижка недоступна, оскільки заробіток за основним продуктом відсутній.</small>
          <small v-else-if="!checkDiscountLimitThreshold() || checkDiscountLimitThreshold() == 0">Не менше нетто-платежу та не більше повної ціни полісу.</small>
          <small v-else >Не менше макс знижки та не більше повної ціни полісу.</small>
          <small class="error" v-if="!$v.paySum.min && submited">Cума повинна бути більше {{minValueForPaySum}} грн</small>
          <small class="error" v-else-if="!$v.paySum.max && submited">Cума повинна бути меньше {{maxValueForPaySum}} грн</small>
          <small class="error" v-else-if="$v.paySum.$dirty && !$v.paySum.required && submited">Введіть бажану суму</small>
          <small class="error" v-else-if="(($v.paySum.$dirty && !$v.paySum.minLength) || ($v.paySum.$dirty && !$v.paySum.maxLength)) && submited">Введіть коректну суму</small>
        </div>
          <div class="row">
              <div class="col-lg-6 col-sm-12 flex-column align-items-center">
                    <button
                      v-if="!checkDiscountLimitThreshold() || checkDiscountLimitThreshold() == 0"
                      :readonly="setDiscountedPriceStatus || dataOtpFlags.confirmOtpStatus || isDiscountDisabled" :disabled="setDiscountedPriceStatus || dataOtpFlags.confirmOtpStatus || isDiscountDisabled"
                      type="button"
                      v-on:click="formSetNettoDiscount()"
                      class="btn prop-button btn-outline-blue">
                      Застосувати НЕТТО
                    </button>
                    <button
                      v-else
                      :readonly="setDiscountedPriceStatus || dataOtpFlags.confirmOtpStatus || isDiscountDisabled" :disabled="setDiscountedPriceStatus || dataOtpFlags.confirmOtpStatus || isDiscountDisabled"
                      type="button"
                      v-on:click="formSetNettoDiscount()"
                      class="btn prop-button btn-outline-blue">
                      Макс-на знижка
                    </button>
              </div>
              <div class="col-lg-6 col-sm-12 flex-column align-items-center">
                  <button
                      :readonly="!isValidPaySum || setDiscountedPriceStatus || dataOtpFlags.confirmOtpStatus" :disabled="!isValidPaySum || setDiscountedPriceStatus || dataOtpFlags.confirmOtpStatus"
                      type="button"
                      v-on:click="formSetDiscount()"
                      class="btn btn-blue">
                      Застосувати
                  </button>
              </div>
          </div>
      </div>
    </div>
  </div>
</template>



<script>

import VueSlider from 'vue-slider-component';
export default {
  props: {
    dataConfirmContractStatus: Boolean,
    dataSetDiscountedPriceStatus: Boolean,
    dataLoading: Boolean,
    dataExtraEarnings: {
      type: [Number, String],
      default: () => {
        return 0;
      }
    },
    dataFullInfo: Object,
    dataOtpFlags: Object,
  },
  components: { VueSlider },
  data() {
    return {
      paySum: null,
      submited: null,
      setDiscountedPriceStatus: false,
      dynamicEarnings: 0,
      isDiscountApplied: false,
    };
  },
  validations: {
    paySum:{
      min: function(value) {
        if (!value) return true;
        return value >= this.minDiscountPrice;
      },
      max: function(value) {
        if (!value) return true;
        return value <= this.maxValueForPaySum;
      }
    },
  },
  created(){
    this.setDiscountedPriceStatus = this.dataSetDiscountedPriceStatus || false;
    this.dynamicEarnings = this.fullInfo.dynamicEarnings || 0;
  },
  mounted() {
    this.$nextTick(() => {
      this.setPaySum();
    });
  },
  computed:{
    fullInfo() {
      return this.dataFullInfo;
    },
    user() {
      return this.$store.getters.USER;
    },
    isValidPaySum() {
      if (!this.paySum) return true;
      return this.paySum >= this.minValueForPaySum && this.paySum <= this.maxValueForPaySum;
    },
    minDiscountPrice() {
      const netto = this.nettoPrice;
      const dgoEarning = Number(this.fullInfo?.dgoEarning || this.fullInfo?.dgo?.earning || 0);
      const lawyerEarning = Number(this.fullInfo?.autolawyerEarning || this.fullInfo?.autolawyer?.earning || 0);
      const osagoEarnings = this.osagoBaseEarnings();

      const threshold = this.checkDiscountLimitThreshold();

      let minPrice = netto;

      if (threshold > 0) {
        // Застосовуємо поріг тільки до заробітку за ОСЦПВ
        // Мінімальна ціна = Нетто (0 заробітку) + (Заробіток ОСЦПВ * Поріг) + Весь заробіток ДЦВ + Весь заробіток Автоюриста
        minPrice = Math.ceil(netto + (osagoEarnings * threshold / 100) + dgoEarning + lawyerEarning);
      }

      const max = Math.floor(this.maxValueForPaySum);

      if (minPrice > max) {
        return max;
      }

      return minPrice;
    },
    nettoPrice() {
      const fullPrice = this.maxValueForPaySum;
      const fullEarnings = this.osagoTotalEarnings();

      return Math.ceil(Math.max(1, fullPrice - fullEarnings));
    },
    isDiscountDisabled() {
      const dgoEarning = Number(this.fullInfo?.dgoEarning || this.fullInfo?.dgo?.earning || 0);
      const lawyerEarning = Number(this.fullInfo?.autolawyerEarning || this.fullInfo?.autolawyer?.earning || 0);
      const earnings = Number(this.fullInfo?.earnings || 0);
      const productEarnings = Number((earnings - dgoEarning - lawyerEarning).toFixed(2));

      return productEarnings <= 0;
    },
    minValueForPaySum() {
      return Math.ceil(this.minDiscountPrice) || 1;
    },
    maxValueForPaySum() {
      const basePrice = Number(this.fullInfo?.startPrice) || Number(this.fullInfo?.originalPrice) || Number(this.fullInfo?.price) || 0;
      // const basePrice = Number(this.fullInfo?.originalPrice) || Number(this.fullInfo?.price) || 0;
      const dgo = Number(this.fullInfo?.dgoPrice || this.fullInfo?.dgo?.cost || this.fullInfo?.dgo?.price || 0);
      const lawyer = Number(this.fullInfo?.autolawyerPrice || this.fullInfo?.autolawyer?.price || 0);

      return Math.floor(basePrice + dgo + lawyer);
    },
    sliderDotOptions() {
      return {
        min: Math.floor(this.minDiscountPrice)
      };
    },
    sliderProcess() {
      const min = Math.floor(this.nettoPrice);
      const max = Math.floor(this.maxValueForPaySum);
      const threshold = Math.ceil(this.minDiscountPrice);

      if (max <= min) return true;

      const thresholdPct = ((threshold - min) / (max - min)) * 100;

      return dotsPos => {
        const currentPos = dotsPos[0];
        const segments = [[0, thresholdPct, { backgroundColor: '#ff0002' }]];
        if (currentPos > thresholdPct) {
          segments.push([thresholdPct, currentPos, { backgroundColor: '#fc9b13' }]);
        }
        return segments;
      };
    },
    sliderMarks() {
      const marks = {};
      const netto = Math.ceil(this.nettoPrice);
      const minPrice = Math.ceil(this.minDiscountPrice);
      const max = Math.floor(this.maxValueForPaySum);

      marks[netto] = {
        label: '',
        style: { color: '#999', fontSize: '10px' }
      };

      if (minPrice > netto) {
        marks[minPrice] = {
          label: '',
          style: { color: '#ff4d4f', fontSize: '10px', fontWeight: 'bold' }
        };
      }

      marks[max] = {
        label: '',
        style: { color: '#999', fontSize: '10px' }
      };

      return marks;
    }
  },
  watch: {
    paySum(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.setDiscountedPriceStatus = false;
        this.isDiscountApplied = false;
        this.$emit('update:priceChanged');
      }
    },
    dataFullInfo: {
      handler(newVal, oldVal) {
        const getMax = (v) =>
          Math.floor(
            (Number(v?.startPrice) || Number(v?.price) || 0) +
            (Number(v?.dgoPrice || v?.dgo?.cost || v?.dgo?.price || 0)) +
            (Number(v?.autolawyerPrice || v?.autolawyer?.price || 0))
          );

        const oldMax = getMax(oldVal);
        const newMax = getMax(newVal);

        const min = Math.ceil(this.minValueForPaySum);
        if (this.paySum < min) {
          this.paySum = min;
        }
        if (this.paySum > newMax) {
          this.paySum = newMax;
        }

        if (oldMax !== newMax) {
          this.isDiscountApplied = false;
          this.setDiscountedPriceStatus = false;
          this.setPaySum();
        } else if (!this.isDiscountApplied) {
          this.setPaySum();
        }
      },
      deep: true
    },
  },
  methods: {
    checkDiscountLimitThreshold(){
      return Number(this.user?.discountLimitThreshold) || 0;
    },
    setPaySum() {
      const max = Math.floor(this.maxValueForPaySum);
      const min = Math.ceil(this.minValueForPaySum);

      if (this.isDiscountDisabled) {
        this.paySum = max;
        return;
      }

      const osagoDiscountPrice = Number(this.dataFullInfo.dynamicDiscountPrice) || 0;
      const dgo = Number(this.fullInfo?.dgoPrice || this.fullInfo?.dgo?.cost || this.fullInfo?.dgo?.price || 0);
      const lawyer = Number(this.fullInfo?.autolawyerPrice || this.fullInfo?.autolawyer?.price || 0);

      if (osagoDiscountPrice > 0) {
        const totalDiscountPrice = osagoDiscountPrice + dgo + lawyer;
        this.paySum = Math.max(Math.floor(totalDiscountPrice), min);
      } else {
        this.paySum = max;
      }
    },
    osagoPrice() {
      return Number(this.fullInfo?.startPrice) || Number(this.fullInfo?.price) || 0;
    },
    osagoTotalEarnings() {
      const dgoEarning = Number(this.fullInfo?.dgoEarning || this.fullInfo?.dgo?.earning || 0);
      const lawyerEarning = Number(this.fullInfo?.autolawyerEarning || this.fullInfo?.autolawyer?.earning || 0);
      const baseEarnings = this.osagoBaseEarnings();
      return baseEarnings + dgoEarning + lawyerEarning;
    },
    osagoBaseEarnings() {
      const dgoEarning = Number(this.fullInfo?.dgoEarning || this.fullInfo?.dgo?.earning || 0);
      const lawyerEarning = Number(this.fullInfo?.autolawyerEarning || this.fullInfo?.autolawyer?.earning || 0);
      return this.fullInfo?.startEarnings !== undefined ? Number(this.fullInfo.startEarnings) : (Number(this.fullInfo?.earnings || 0) - dgoEarning - lawyerEarning);
    },
    dgoAutolayerPrice() {
      const dgo = Number(this.fullInfo?.dgoPrice || this.fullInfo?.dgo?.cost || this.fullInfo?.dgo?.price || 0);
      const lawyer = Number(this.fullInfo?.autolawyerPrice || this.fullInfo?.autolawyer?.price || 0);
      return dgo + lawyer;
    },
    calculateInterval(min, max) {
      if (!min || min >= max) return 1;
      let difference = max - min;
      let interval = 10;

      while (difference % interval !== 0) {
        interval--;
        if (interval <= 1) break;
      }
      return interval;
    },
    formSetNettoDiscount() {
      this.paySum = this.minValueForPaySum;
      this.formSetDiscount();
    },
    formSetDiscount() {
      this.submited = true;
      this.isDiscountApplied = true;
      let paySum = parseFloat(this.paySum);

      const totalFullPrice = this.maxValueForPaySum;
      const totalEarnings = this.osagoTotalEarnings();
      const minAllowed = this.minValueForPaySum;

      if (paySum < minAllowed) {
        paySum = minAllowed;
        this.paySum = paySum;
      }

      if (paySum >= totalFullPrice || !paySum || isNaN(paySum)) {
        this.setDiscountedPriceStatus = true;
        this.$nextTick(() => {
          this.$emit('update:tooltip', {
            ...this.fullInfo,
            discountPrice: 0,
            discountPercent: 0,
            discountedSum: 0,
            earnings: (Number(this.fullInfo?.startEarnings) || Number(this.fullInfo?.earnings))
          });
        });
      } else {
        const dgoCost = Number(this.fullInfo.dgoPrice || this.fullInfo.dgo?.cost || this.fullInfo.dgo?.price || 0);
        const lawyerCost = Number(this.fullInfo.autolawyerPrice || this.fullInfo.autolawyer?.price || 0);
        const osagoBasePrice = this.osagoPrice();

        const osagoDiscountedPrice = +(paySum - dgoCost - lawyerCost).toFixed(2);
        const osagoDiscountedSum = +(osagoBasePrice - osagoDiscountedPrice).toFixed(2);
        const osagoDiscountPercent = osagoBasePrice > 0 ? +(osagoDiscountedSum * 100 / osagoBasePrice).toFixed(2) : 0;

        const totalDiscountSum = totalFullPrice - paySum;
        const kvd = +(totalEarnings - totalDiscountSum).toFixed(2);

        this.setDiscountedPriceStatus = true;
        this.$nextTick(() => {
          this.$emit('update:tooltip', {
            ...this.fullInfo,
            discountPrice: osagoDiscountedPrice,
            discountPercent: osagoDiscountPercent,
            discountedSum: osagoDiscountedSum,
            earnings: kvd
          });
        });
      }
    },
  }
};
</script>
<style scoped>
span.red{
  color: red;
  font-weight: bold;
}
.discount-info-block{
  background: #F6F7FB;
  padding: 30px 30px;
}
@media(max-width: 991px){
  .discount-info-block{
    margin: 10px 0;
    padding: 4px 30px;
  }
}

</style>
